export default __webpack_public_path__ + "static/wall2-min-7b13faf72bb6c418615c28152a5a9d8a.png";